import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { Expose, Model, ModelId } from '@core/shared/model';
import { AppRequestMethod } from '@core/shared/request';
let RemoveMediaAssetMappingResponse = /*#__PURE__*/(() => {
  let RemoveMediaAssetMappingResponse = class RemoveMediaAssetMappingResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Boolean)], RemoveMediaAssetMappingResponse.prototype, "success", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], RemoveMediaAssetMappingResponse.prototype, "count", void 0);
  RemoveMediaAssetMappingResponse = __decorate([ModelId("RemoveMediaAssetMappingResponse") // auto-generated by generate-model-ids
  ], RemoveMediaAssetMappingResponse);
  return RemoveMediaAssetMappingResponse;
})();
export { RemoveMediaAssetMappingResponse };
let RemoveManyMediaAssetMappingRequest = /*#__PURE__*/(() => {
  let RemoveManyMediaAssetMappingRequest = class RemoveManyMediaAssetMappingRequest extends Model {
    static {
      this.Response = RemoveMediaAssetMappingResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", String)], RemoveManyMediaAssetMappingRequest.prototype, "consumerName", void 0);
  __decorate([Expose(), __metadata("design:type", Array)], RemoveManyMediaAssetMappingRequest.prototype, "consumerIds", void 0);
  __decorate([Expose(), __metadata("design:type", String)], RemoveManyMediaAssetMappingRequest.prototype, "mediaSlot", void 0);
  RemoveManyMediaAssetMappingRequest = __decorate([AppRequest('admin/media', 'mappings/remove-many', {
    httpMethod: false
  }), ModelId("RemoveManyMediaAssetMappingRequest") // auto-generated by generate-model-ids
  ], RemoveManyMediaAssetMappingRequest);
  return RemoveManyMediaAssetMappingRequest;
})();
export { RemoveManyMediaAssetMappingRequest };
let RemoveMediaAssetMappingRequest = /*#__PURE__*/(() => {
  let RemoveMediaAssetMappingRequest = class RemoveMediaAssetMappingRequest extends Model {
    static {
      this.Response = RemoveMediaAssetMappingResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", String)], RemoveMediaAssetMappingRequest.prototype, "consumerName", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], RemoveMediaAssetMappingRequest.prototype, "consumerId", void 0);
  __decorate([Expose(), __metadata("design:type", Array)], RemoveMediaAssetMappingRequest.prototype, "mediaSlots", void 0);
  RemoveMediaAssetMappingRequest = __decorate([AppRequest('admin/media', 'mappings/remove', {
    httpMethod: false
  }), ModelId("RemoveMediaAssetMappingRequest") // auto-generated by generate-model-ids
  ], RemoveMediaAssetMappingRequest);
  return RemoveMediaAssetMappingRequest;
})();
export { RemoveMediaAssetMappingRequest };
let RemoveMediaAssetMappingByAssetRequest = /*#__PURE__*/(() => {
  let RemoveMediaAssetMappingByAssetRequest = class RemoveMediaAssetMappingByAssetRequest extends Model {
    static {
      this.Response = RemoveMediaAssetMappingResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Number)], RemoveMediaAssetMappingByAssetRequest.prototype, "assetId", void 0);
  RemoveMediaAssetMappingByAssetRequest = __decorate([AppRequest('admin/media', 'mappings/remove-by-asset', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("RemoveMediaAssetMappingByAssetRequest") // auto-generated by generate-model-ids
  ], RemoveMediaAssetMappingByAssetRequest);
  return RemoveMediaAssetMappingByAssetRequest;
})();
export { RemoveMediaAssetMappingByAssetRequest };